<script setup lang="ts">
import { computed, watch } from 'vue'
import { RouterView, useRoute, useRouter } from 'vue-router'
import AppShell from './components/AppShell.vue'
import BienvenidaOverlay from './components/BienvenidaOverlay.vue'
import ConfirmDialog from './components/ConfirmDialog.vue'
import { useAuthStore } from './stores/auth'
import { useColaStore } from './stores/cola'
import { useConexionStore } from './stores/conexion'

const route = useRoute()
const router = useRouter()
const auth = useAuthStore()

// Conectividad y cola offline viven mientras la app esté abierta.
useConexionStore().iniciar()
useColaStore().iniciar()

const showShell = computed(() => auth.isAuthenticated && route.meta?.layout !== 'minimal')

// Red de seguridad: si la sesión se pierde por cualquier vía (logout, expiración,
// otra pestaña) mientras estamos en una ruta protegida, vamos al login. Sin esto la
// vista quedaba montada sin barra, porque el guard solo corre al navegar.
watch(
  () => auth.isAuthenticated,
  (autenticado) => {
    if (!autenticado && auth.bootstrapped && route.meta?.requiresAuth) {
      router.replace({ name: 'login', query: { next: route.fullPath } })
    }
  },
)
</script>

<template>
  <AppShell v-if="showShell">
    <RouterView />
  </AppShell>
  <RouterView v-else />
  <ConfirmDialog />
  <BienvenidaOverlay />
</template>
